var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.909058,
    width: 40,
    height: 40,
    rx: 20,
    className: "ext3_2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2885_13599)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ext3_2_i",
    d: "M20.0316 26.1351C20.3091 26.1351 20.5416 25.9101 20.5416 25.6251C20.5416 25.3476 20.3166 25.1151 20.0316 25.1151H12.7941C12.5166 25.1151 12.2841 25.3401 12.2841 25.6251C12.2841 25.9026 12.5091 26.1351 12.7941 26.1351H20.0316Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ext3_2_i",
    d: "M20.5416 23.7425C20.5416 24.0275 20.3091 24.2525 20.0316 24.2525H12.7941C12.5091 24.2525 12.2841 24.02 12.2841 23.7425C12.2841 23.4575 12.5166 23.2325 12.7941 23.2325H20.0316C20.3166 23.225 20.5416 23.4575 20.5416 23.7425Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ext3_2_i",
    d: "M20.0316 22.3625C20.3091 22.3625 20.5416 22.1375 20.5416 21.8525C20.5416 21.575 20.3166 21.3425 20.0316 21.3425H12.7941C12.5166 21.3425 12.2841 21.5675 12.2841 21.8525C12.2841 22.13 12.5091 22.3625 12.7941 22.3625H20.0316Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ext3_2_i",
    d: "M20.5416 19.97C20.5416 20.255 20.3091 20.48 20.0316 20.48H12.7941C12.5091 20.48 12.2841 20.2475 12.2841 19.97C12.2841 19.685 12.5166 19.46 12.7941 19.46H20.0316C20.3166 19.4525 20.5416 19.685 20.5416 19.97Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ext3_2_i",
    d: "M20.0316 18.59C20.3091 18.59 20.5416 18.365 20.5416 18.08C20.5416 17.8025 20.3166 17.57 20.0316 17.57H12.7941C12.5166 17.57 12.2841 17.795 12.2841 18.08C12.2841 18.3575 12.5091 18.59 12.7941 18.59H20.0316Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ext3_2_i",
    d: "M23.7516 26.1274C24.2694 26.1274 24.6891 25.7077 24.6891 25.1899C24.6891 24.6722 24.2694 24.2524 23.7516 24.2524C23.2338 24.2524 22.8141 24.6722 22.8141 25.1899C22.8141 25.7077 23.2338 26.1274 23.7516 26.1274Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ext3_2_i",
    d: "M28.8741 25.1899C28.8741 25.7077 28.4544 26.1274 27.9366 26.1274C27.4189 26.1274 26.9991 25.7077 26.9991 25.1899C26.9991 24.6722 27.4189 24.2524 27.9366 24.2524C28.4544 24.2524 28.8741 24.6722 28.8741 25.1899Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ext3_2_i",
    d: "M22.7466 17.195C22.0445 17.195 21.4716 17.7679 21.4716 18.47V22.0925C21.4716 22.7946 22.0445 23.3675 22.7466 23.3675H28.6491C29.3512 23.3675 29.9241 22.7946 29.9241 22.0925V18.47C29.9241 17.7679 29.3512 17.195 28.6491 17.195H22.7466ZM23.2265 20.465C23.2265 20.1425 23.489 19.8725 23.819 19.8725C24.149 19.8725 24.4115 20.1425 24.419 20.465V22.6175H23.2265V20.465Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ext3_2_i",
    d: "M14.8773 14.0774L27.3758 11.6171C27.4761 11.261 27.8034 11 28.1916 11C28.2296 11 28.267 11.0025 28.3037 11.0073C28.3381 11.0025 28.3733 11 28.4091 11C28.8233 11 29.1591 11.3358 29.1591 11.75C29.1591 11.9795 29.056 12.1849 28.8936 12.3225C28.7412 12.5473 28.4837 12.695 28.1916 12.695C27.9137 12.695 27.6671 12.5613 27.5125 12.3546L16.0672 14.6075H29.4441C30.9468 14.6075 32.1562 15.8207 32.1665 17.3174L32.1666 17.3225L32.1666 26.5175C32.1666 28.0193 30.9458 29.24 29.4441 29.24H29.0766V29.2775C29.0766 29.8475 28.6116 30.305 28.0491 30.305C27.4791 30.305 27.0216 29.8475 27.0216 29.2775V29.24H14.7141V29.2775C14.7141 29.8475 14.2566 30.305 13.6866 30.305C13.1166 30.305 12.6591 29.8475 12.6591 29.2775V29.24H12.3816C10.8798 29.24 9.65906 28.0193 9.65906 26.5175V17.33C9.65906 15.8283 10.8798 14.6075 12.3816 14.6075H12.7052C12.9675 14.142 13.4666 13.8275 14.0391 13.8275C14.3486 13.8275 14.6366 13.9194 14.8773 14.0774ZM12.7052 16.1075H12.3816C11.7083 16.1075 11.1591 16.6568 11.1591 17.33V26.5175C11.1591 27.1908 11.7083 27.74 12.3816 27.74H29.4441C30.1173 27.74 30.6666 27.1908 30.6666 26.5175V17.3255C30.6607 16.6482 30.1156 16.1075 29.4441 16.1075H15.373C15.1106 16.5731 14.6116 16.8875 14.0391 16.8875C13.4666 16.8875 12.9676 16.5731 12.7052 16.1075Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2885_13599"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ext3_2_i",
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8.90906 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio);
export default __webpack_public_path__ + "static/media/Radio.e970210c.svg";
export { ForwardRef as ReactComponent };